// src/routes/merchants/catalogue/RegionLabel.tsx
import './brands.css'

/** A brand's region, as visible text: "CA" or "US" (owner decision C1). Never colour alone. */
export function RegionLabel({ region }: { region: string }) {
  return <span className="brand-region">{region}</span>
}
